import { useMutation } from '@tanstack/vue-query'
import type { UpdateContractInput } from '~/resources/graphql/graphql'
import { graphql } from '~/resources/graphql'
import { useRpQuery } from '~/composables/graphql'
import { useActiveFacility } from '~/composables/use-active-facility'

export function useAgreementUpdateContractMutation() {
    const query = useRpQuery()
    const activeFacility = useActiveFacility()

    return useMutation({
        mutationFn: (mutationData: UpdateContractInput) =>
            query(
                graphql(/** @lang GraphQL */ `
                    mutation AgreementUpdateContractMutation(
                        $input: UpdateContractInput!
                        $facilityId: ID!
                    ) {
                        updateContract(input: $input) {
                            __typename
                            ... on UpdateContractResult {
                                record {
                                    __typename
                                    ... on PlanContract {
                                        ...PurchaseAgreementContractFragment
                                    }
                                }
                                query {
                                    viewer {
                                        cart(facilityId: $facilityId) {
                                            ...ViewerCartFragment
                                        }
                                    }
                                }
                            }
                            ... on ValidationError {
                                fieldErrors {
                                    message
                                }
                            }
                        }
                    }
                `),
                {
                    input: mutationData,
                    facilityId: activeFacility.value.id
                }
            )
    })
}
